export const StockValidationConstants = {
    APPLIED_STORE_FILTER: 'STOCK_VALIDATION/APPLIED_STORE_FILTER'
};
